const PIXEL_SCRIPT_ID = "meta-pixel-tracker";

const loadPixelScript = (pixelId) => {
  if (document.getElementById(PIXEL_SCRIPT_ID)) {
    console.log("[Meta Pixel] Script already loaded.");
    return;
  }

  console.log(`[Meta Pixel] Injecting script for Pixel ID: ${pixelId}`);

  (function (f, b, e, v, n, t, s) {
    if (f.fbq) return;
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = !0;
    n.version = "2.0";
    n.queue = [];
    t = b.createElement(e);
    t.async = !0;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
  })(
    window,
    document,
    "script",
    "https://connect.facebook.net/en_US/fbevents.js"
  );

  window.fbq("init", pixelId);
  window.fbq("track", "PageView");

  console.log("[Meta Pixel] Initialized and PageView tracked.");
};

export const initiateMetaPixel = (metaPixelIntegration) => {
  try {
    if (metaPixelIntegration) {
      const { enabled, config } = metaPixelIntegration;
      if (enabled && config?.pixelId) {
        loadPixelScript(config.pixelId);
      } else {
        console.log("[Meta Pixel] Not enabled or Pixel ID missing.");
      }
    } else {
      console.warn("No integration record found for Meta Pixel.");
    }
  } catch (err) {
    console.error("Failed to load Meta Pixel:", err);
  }
};
